module.exports = __webpack_public_path__ + "img/Logo_GEF.71ee97ea.png";